import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';

export class UrlActions {
    public static updateUrlArgumentsStore(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.HASH_CHANGED
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/UrlActions.ts